import {
  CORE_DATASOURCES,
  EO_PAGEVIEW,
  COST,
  COST_IN_LOCAL_CURRENCY,
} from '../../../../common/support/eo_mapping/datasources';
import {
  COST_CALCULATIONS_IN_DEFAULT_CURRENCY,
  COST_CALCULATIONS_IN_LOCAL_CURRENCY,
  REVENUE_CALCULATIONS,
  CLICK_TO_EVENT_CALCULATIONS,
} from '../../../../common/support/eo_mapping/calculations';

export const ADS_DATASOURCES_DEFAULT_CURRENCY = Object.keys({ ...CORE_DATASOURCES, [COST]: COST }).filter(
  (e) => e !== EO_PAGEVIEW
);
export const ADS_DATASOURCES = [...ADS_DATASOURCES_DEFAULT_CURRENCY, COST_IN_LOCAL_CURRENCY];

export const ADS_CALCULATIONS_DEFAULT_CURRENCY = [
  ...CLICK_TO_EVENT_CALCULATIONS,
  ...COST_CALCULATIONS_IN_DEFAULT_CURRENCY,
  ...REVENUE_CALCULATIONS,
];
export const ADS_CALCULATIONS = [...ADS_CALCULATIONS_DEFAULT_CURRENCY, ...COST_CALCULATIONS_IN_LOCAL_CURRENCY];
